import React from 'react';
import PropTypes from 'prop-types';
import { FilterButton, FilterToggle } from '@components/search_filters/units';
import { FILTERS_SCHEMA } from '@components/search_filters/constants';
import {
  selectedEngineSizeToString,
  selectedLocationToString,
  selectedMakeToString,
  selectedMakeModelsToString,
  selectedMakeModelsTrimsToString,
  selectedMPGToString,
  selectedPriceToString,
  selectedRoadTaxToString,
  selectedToUpToString,
  selectedValueToString,
} from '@components/search_filters/helpers/selectedOptionsDisplay';

const VehicleSearchFilters = ({
  appliedFilters,
  onFilterClick,
  onToggleChange,
}) => {
  const getFilterButtonProps = (filter) => {
    const { id, name } = filter;
    const selectedOptions = selectedValueToString(appliedFilters, id);
    return {
      id,
      name,
      onClick: () => onFilterClick(filter),
      selectedOptions,
    };
  };

  const disableModel = () => {
    return Object.keys(appliedFilters.makeModel).length === 0;
  };

  const disableTrim = () => {
    if (disableModel()) {
      return true;
    }

    return !Object.keys(appliedFilters.makeModel)
      .map((make) => {
        return Object.keys(appliedFilters.makeModel[make].models).length !== 0;
      })
      .includes(true);
  };

  const isTrimDisabled = disableTrim();

  return (
    <>
      <div className="filter__body">
        <FilterButton
          id="make"
          name="Makes"
          onClick={() => onFilterClick(FILTERS_SCHEMA.make)}
          selectedOptions={selectedMakeToString(appliedFilters.makeModel)}
        />
        <FilterButton
          disabled={disableModel()}
          id="model"
          name="Models"
          onClick={() => onFilterClick(FILTERS_SCHEMA.model)}
          selectedOptions={selectedMakeModelsToString(appliedFilters.makeModel)}
        />
        <FilterButton
          disabled={isTrimDisabled}
          id="trim"
          name="Model variants"
          onClick={() => onFilterClick(FILTERS_SCHEMA.trim)}
          selectedOptions={
            isTrimDisabled
              ? ''
              : selectedMakeModelsTrimsToString(appliedFilters.makeModel)
          }
        />
        <FilterButton
          id="location"
          name="Distance from you"
          onClick={() => onFilterClick(FILTERS_SCHEMA.location)}
          {...selectedLocationToString(appliedFilters)}
        />
        <FilterButton
          id="price"
          name="Price"
          onClick={() => onFilterClick(FILTERS_SCHEMA.price)}
          selectedOptions={selectedPriceToString(appliedFilters)}
        />
        {/* <FilterToggle
          checked={appliedFilters.promotion}
          id="promotion"
          labelText={<span>Show discounted cars</span>}
          name="Promotion"
          onChange={(id, value) => onToggleChange({ [id]: value })}
        /> */}
        <FilterToggle
          checked={appliedFilters.unreservedOnly}
          id="unreservedOnly"
          labelText={<span>Hide reserved cars</span>}
          onChange={(id, value) => onToggleChange({ [id]: value })}
        />
        <FilterButton
          id="age"
          name="Age"
          onClick={() => onFilterClick(FILTERS_SCHEMA.age)}
          {...selectedToUpToString(appliedFilters.age, 'year%s% old')}
        />
        <FilterButton {...getFilterButtonProps(FILTERS_SCHEMA.transmission)} />
        <FilterButton {...getFilterButtonProps(FILTERS_SCHEMA.fuelType)} />
        <FilterButton
          id="mileage"
          name="Mileage"
          onClick={() => onFilterClick(FILTERS_SCHEMA.mileage)}
          {...selectedToUpToString(appliedFilters.mileage, 'miles')}
        />
        <FilterButton {...getFilterButtonProps(FILTERS_SCHEMA.searchType)} />
        <FilterButton {...getFilterButtonProps(FILTERS_SCHEMA.bodyType)} />
        <FilterButton
          id="engine"
          name="Engine size"
          onClick={() => onFilterClick(FILTERS_SCHEMA.engine)}
          selectedOptions={selectedEngineSizeToString(appliedFilters)}
        />
        <FilterButton {...getFilterButtonProps(FILTERS_SCHEMA.colour)} />
        <FilterButton
          {...getFilterButtonProps(FILTERS_SCHEMA.seats)}
          name="Seats"
          selectedOptions={selectedValueToString(
            appliedFilters,
            FILTERS_SCHEMA.seats.id,
            'seats'
          )}
        />
        <FilterButton
          id="door"
          name="Doors"
          onClick={() => onFilterClick(FILTERS_SCHEMA.doors)}
          selectedOptions={selectedValueToString(
            appliedFilters,
            FILTERS_SCHEMA.doors.id,
            'doors'
          )}
        />
        <FilterButton {...getFilterButtonProps(FILTERS_SCHEMA.driveTrain)} />
        <FilterButton
          id="mpg"
          name="Fuel consumption"
          onClick={() => onFilterClick(FILTERS_SCHEMA.mpg)}
          selectedOptions={selectedMPGToString(appliedFilters)}
          subLabel="(MPG)"
        />
        <FilterButton
          id="roadtaxCost"
          name="Vehicle tax"
          onClick={() => onFilterClick(FILTERS_SCHEMA.roadtaxCost)}
          selectedOptions={selectedRoadTaxToString(appliedFilters)}
          subLabel="(per year)"
        />
      </div>
    </>
  );
};

export default VehicleSearchFilters;

VehicleSearchFilters.propTypes = {
  appliedFilters: PropTypes.object.isRequired,
  onFilterClick: PropTypes.func.isRequired,
  onToggleChange: PropTypes.func.isRequired,
};
